import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { MotionRoot } from '@/components/generals/motion-root'
import { PageHero } from '@/components/generals/page-hero'
import { NextPage } from '@/components/generals/next-page'
import { GalleryGrid } from '@/components/subpages/gallery-grid'
import { nextPageAfter, pages } from '@/constants/pages'

const page = pages.gallery
const next = nextPageAfter('gallery')

const GalleryPage: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title={page.seoTitle} description={page.description} ogImage={page.image.src} />

            <MotionRoot>
                <PageHero
                    index={page.index}
                    eyebrow={page.eyebrow}
                    title={page.title}
                    accent={page.accent}
                    image={page.image}
                    facts={page.facts}
                    next='photographs'
                />

                <GalleryGrid />

                <NextPage
                    href={next.href}
                    index={next.index}
                    title={next.title}
                    teaser={next.teaser}
                    image={next.image}
                />
            </MotionRoot>
        </Layout>
    )
}

export default GalleryPage
